import { z } from 'zod';
import {
  AdHocInvoiceId,
  FamilyAccountTransactionId,
  FamilyId,
  RecurringFeeAssignmentId,
  StudentId,
  AcademicYear,
} from '../types/branded';
import {
  BillingCategorySchema,
  LedgerEntrySourceSchema,
  LedgerEntryStatusSchema,
  LedgerEntryTypeSchema,
} from '../types/enums';

export const FamilyAccountTransactionSchema = z.object({
  id: FamilyAccountTransactionId,
  familyId: FamilyId,
  studentId: StudentId.nullable().optional(),
  academicYear: AcademicYear,
  entryType: LedgerEntryTypeSchema,
  amount: z.number(),
  description: z.string().nullable().optional(),
  referenceCode: z.string().nullable().optional(),
  status: LedgerEntryStatusSchema,
  effectiveDate: z.string(),
  createdAt: z.string(),
  createdBy: z.string().nullable().optional(),
  relatedEntryId: z.string().nullable().optional(),
  disputeId: z.string().nullable().optional(),
  disputeDeadline: z.string().nullable().optional(),
  isReversed: z.boolean().default(false),
  billingCategory: BillingCategorySchema.nullable().optional(),
  adhocInvoiceId: AdHocInvoiceId.nullable().optional(),
  recurringFeeAssignmentId: RecurringFeeAssignmentId.nullable().optional(),
  source: LedgerEntrySourceSchema.nullable().optional(),
}).superRefine((value, ctx) => {
  if (
    (value.entryType === 'reversal'
      || value.entryType === 'refund'
      || value.entryType === 'chargeback')
    && !value.relatedEntryId
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'relatedEntryId is required for reversal, refund, and chargeback entries.',
      path: ['relatedEntryId'],
    });
  }

  if (value.entryType === 'chargeback' && !value.disputeId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'disputeId is required for chargeback entries.',
      path: ['disputeId'],
    });
  }

  if (value.entryType === 'chargeback' && !value.disputeDeadline) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'disputeDeadline is required for chargeback entries.',
      path: ['disputeDeadline'],
    });
  }
});
export type FamilyAccountTransaction = z.infer<typeof FamilyAccountTransactionSchema>;
